import { RealSuiteNumber, Suite } from "@ssc-booking/api-contracts"
import * as F from "fp-ts/function"
import * as RONEA from "fp-ts/ReadonlyNonEmptyArray"
import * as N from "fp-ts/number"
import * as ROA from "fp-ts/ReadonlyArray"
import * as A from "fp-ts/Array"
import * as O from "fp-ts/Option"
import { Option } from "fp-ts/Option"
import { contramap } from "fp-ts/Ord"
import { ReadonlyNonEmptyArray } from "fp-ts/ReadonlyNonEmptyArray"
import { AvailableSuitesLoaderTypes } from "../_common/machines/ecommerce-machine/data-loading/available-suites-loader-machine"

import { ECommerceContext } from "../_common/machines/ecommerce-machine/e-commerce-machine-context"

export const selectedDeckOrDefault = (selectedSuite: O.Option<Suite>, availableSuites: ReadonlyNonEmptyArray<Suite>) =>
    F.pipe(
        selectedSuite,
        O.map((x) => x.deck),
        O.getOrElse(() => availableSuites[0].deck),
    )

export const getAvailableDeckNumbers = (availableSuites: ReadonlyNonEmptyArray<Suite>): readonly number[] =>
    F.pipe(
        availableSuites,
        RONEA.map((x) => x.deck),
        RONEA.uniq(N.Eq),
    )

export const getAvailableSuiteNumbersByDeckNumber = (
    availableSuites: ReadonlyNonEmptyArray<Suite>,
    deckNumber: number,
): readonly RealSuiteNumber[] =>
    F.pipe(
        availableSuites,
        ROA.filter((x) => x.deck === deckNumber),
        ROA.map((x) => x.number),
    )

export const selectedSuite = (
    context: ECommerceContext,
    contextSA: AvailableSuitesLoaderTypes["LoadedContext"],
): Option<Suite> =>
    F.pipe(
        contextSA.response.suites,
        ROA.findFirst((x) => x.number === context.selectedSuiteNumber),
    )

const byDeckNumber = F.pipe(
    N.Ord,
    contramap((deck: { deckNumber: number }) => deck.deckNumber),
)
export const totalDecks = (
    decks:
        | {
              deckNumber: number
          }[]
        | undefined,
): number | undefined => {
    if (!decks) return undefined

    return F.pipe(
        decks,
        A.sortBy([byDeckNumber]),
        A.last,
        O.fold(F.constUndefined, (deck) => deck.deckNumber),
    )
}
